<template>
  <v-container fluid style="background-color: #fff;height: 93vh;">
    <div v-if="generatingChart" class="loading-overlay">
      <v-progress-circular indeterminate color="primary" size="48" />
      <span style="margin-top: 12px; color: #437EBE; font-weight: bold; display: block;">Gerando Gráfico...</span>
    </div>
    <v-row dense style="margin-bottom: 15px;"
      v-if="isKPI">
      <!-- <v-col cols="2.2">
        <KpiSimpleCard title="Média antes da Foz" :value="selectedSector.length === 0 ? 'Selecione setor ou unidade' : toStringSafe(adjustedAverage)" style="background-color: #DEF6F9;margin: 0px"/>
      </v-col> -->
      <!-- <v-col cols="2.2">
        <KpiSimpleCard title="Meta de economia" :value="selectedSector.length === 0 ? 'Selecione setor ou unidade' : toStringSafe(unitSelectedDataKPIs.goalPercentage)" style="background-color: #DEF6F9;margin: 0px"/>
      </v-col> -->
      <!-- <v-col cols="2.2">
        <KpiSimpleCard title="Meta de consumo" :value="selectedSector.length === 0 ? 'Selecione setor ou unidade' : toStringSafe(goalEconomy)" style="background-color: #DEF6F9;margin: 0px"/>
      </v-col> -->
      <v-col cols="2.2">
        <KpiSimpleCard
          title="Consumo registrado"
          :value="selectedSector.length === 0 ? 'Selecione setor ou unidade' : toStringSafe(recordedConsumption)"
          :info="true"
          :infoText="kpiRecordedConsumptionTip"
          style="background-color: #E0EFFF;margin: 0px"
        />
      </v-col>
      <v-col cols="2.2">
        <KpiSimpleCard
          title="Consumo médio"
          :value="selectedSector.length === 0 ? 'Selecione setor ou unidade' : toStringSafe(averageConsumption)"
          :info="true"
          :infoText="kpiAverageConsumptionTip"
          style="background-color: #E0EFFF; margin: 0px;"
        />
      </v-col>
      <v-col cols="2.2">
        <KpiSimpleCard
          title="Total estimado"
          :value="selectedSector.length === 0 ? 'Selecione setor ou unidade' : toStringSafe(estimatedTotal)"
          :info="true"
          :infoText="kpiEstimatedTotalTip"
          style="background-color: #E0EFFF;margin: 0px"
        />
      </v-col>
      <!-- <v-col cols="2.2">
        <KpiTypeCard title="Tipo de consumo" 
          :water="selectedSector.length === 0 ? 'Selecione setor ou unidade' : toStringSafe(consumptionType[0])" 
          :sewer="selectedSector.length === 0 ? 'Selecione setor ou unidade' : toStringSafe(consumptionType[1])" 
          info :infoText="kpiTipGeneral"  
          style="background-color: #E9E9FF;margin: 0px"/>
      </v-col>    -->
    </v-row>

    <v-row no-gutters v-for="(summedGraph, i) in summedGraphs" :key="i + 123">
      <v-col cols="12" style="padding-bottom: 25px; position: relative;">
        <ConsumptionBarChart
          :title="'Consumo Total'"
          :labels="summedGraph.labels"
          :datasets="summedGraph.dataset"
          :average="0"
          :loading="false"
          :show-goal-line="false"
          @export-pdf="startPdf"
          @export-sheet="exportSheets"
        />
      </v-col>
    </v-row>
    <v-row no-gutters v-for="(dataGraphicUnit, i) in unitsDataGraphic" :key="i">
      <v-col cols="12" style="padding-bottom: 25px; position: relative;" >
        <ConsumptionBarChart
          :title="dataGraphicUnit.unit_name"
          :labels="dataGraphicUnit.labels"
          :datasets="dataGraphicUnit.dataset"
          :average="0"
          :loading="false"
          :show-goal-line="selectedUnitSum.length <= 1"
          @export-pdf="startPdf"
          @export-sheet="exportSheets"
        />
      </v-col>
    </v-row>

    <!-- Gráfico -->

    <v-row v-if="isDataGraphic" no-gutters v-for="(reading, i) in readings" :key="i">
      <v-col
        cols="12"
        :style="{ marginBottom: '15px', height: dynamicHeight, position: 'relative' }"
      >
        <!-- // * Histórico de Consumo -->
        <ConsumptionBarChart 
          :labels="readings[i].labels" 
          :datasets="readings[i].datasets"
          :average="0" 
          :loading="false" 
          title="Consumo"
          :subtitle="getResumeData(reading.modemId, 'modemName')"
          @export-pdf="startPdf"
          @export-sheet="exportSheets"
        />
        <div v-if="exporting" class="loading-overlay">
          <v-progress-circular indeterminate color="primary" size="48" />
          <span style="margin-top: 12px; color: #437EBE; font-weight: bold; display: block;">Exportando Arquivo...</span>
        </div>
      </v-col>
    </v-row>
    <!-- Fim Gráfico -->

    <!-- Tabela -->
    <v-row class="dashboardData" align="center" justify="center" v-if="isDataTable" style="border-radius: 1rem">

      <v-card class="rounded-xl" style="border-radius: 20px;width:98%;" v-for="(reading, i) in readings_table" :key="i">
        <!-- Loading enquanto os dados estiverem sendo carregados -->
        <v-overlay absolute style="opacity: 0.8" :value="loadingReadings">
          <v-progress-circular indeterminate color="primary" v-if="loadingReadings"></v-progress-circular>
        </v-overlay>

        <v-toolbar color="primary" dark dense style="border-radius: 20px 20px 0px 0px">
          Leitura {{ getResumeData(reading.modemId, 'modemName') }}
        </v-toolbar>

        <!-- Tabela de Consumo -->
        <v-card-text>
          <div style="width:100%;text-align:center; border-radius:1rem; border: gray 1px solid">
            <v-data-table :headers="headers_tabledays" :items="reading.items" class="rounded-1"
              style="border-radius:1rem;" dense>
            </v-data-table>
            <div class="consumption-total-style">
              <span style="color: #696969; font-weight: bold; font-size:larger">Consumo Médio Atual: </span>
              <span style="font-size: larger; margin-left: 1rem; font-weight: bold">{{ (getResumeData(reading.modemId,
                'average')).toFixed(2) }} {{ isCubicMetersSelected ? 'm³' : 'L' }}</span>
            </div>
            <div class="consumption-total-style">
              <span style="color: #696969; font-weight: bold; font-size:larger">Consumo Medido:</span>
              <span style="font-size: larger; margin-left: 1rem; font-weight: bold">{{ getResumeData(reading.modemId,
                'measured_total').toFixed(2) }} {{ isCubicMetersSelected ? 'm³' : 'L' }}</span>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-btn v-show="false" small color="primary" text>Baixar Planilha Completa</v-btn>
    </v-row>
    <v-dialog v-model="dialogDownload" max-width="400">
      <v-card>
        <v-card-title class="headline">Salvar Arquivo</v-card-title>
        <v-card-text>
          Clique abaixo para salvar o arquivo.
          <br />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <a :href="fileLink" download>
            <v-btn color="success" text @click="dialogDownload = false">
              Salvar Arquivo
            </v-btn>
          </a>
          <v-btn color="error" text @click="dialogDownload = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>

</template>

<script>
import ConsumptionScript from './ConsumptionScript.js';
import KpiSimpleCard from '@/components/KPI/KpiSimpleCard.vue';
import KpiTypeCard from '@/components/KPI/KpiTypeCard.vue';

const merged = {
  ...(ConsumptionScript || {}),
  components: {
    ...(ConsumptionScript.components || {}),
    KpiSimpleCard,
    KpiTypeCard,
  }
};

export default merged;
</script>

<style lang="scss">
.boxChartsAutoHeighFirstLine {
  border: 1px solid #9fa8da75;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
    0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  height: calc(100vh - 64vh);
  min-height: 300px;
  background-color: white;
  border-radius: 16px;
  overflow: hidden;
  padding: 15px;
}

.litte {
  left: 10px;
}

.consumption-total-style {
  display: flex;
  justify-content: center;
  margin: 10px 0px 10px 0px;
}

.date-picker-height {
  height: 450px
}

.style-div {

  display: flex;
  //justify-content: space-evenly;
  justify-content: flex-start;

}

.layout-data-abstract-fields {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.layout-data-abstract {
  background: #1976d2 !important;
  border-radius: 1rem !important;


}

.style-card-city-name {
  background: #3298ed !important;

  text-align: center !important;
  border-radius: 1rem;
  padding: 1rem;
  font-size: 1rem;
  word-break: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  span {
    color: white;
    font-style: italic;
  }
}

.v-divider {
  border-color: white;
  border-width: 0.05rem;
}

.card-style-data-client {
  color: white !important;
  background: #1976d2 !important;
  text-align: center !important;
  border-style: none !important;
  font-size: 1rem !important;
}

.v-text-field-bar-class {
  border-style: none !important;
}

.text-large {
  font-size: 225%;
  font-weight: 500;
}

.cards {
  padding-top: 5px !important;
  padding-bottom: 4px !important;
  padding-left: 15px !important;
  padding-right: 10px !important;
}

.ticketCards {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

.cardsLG {
  margin-bottom: 5px !important;
  padding-left: 6px !important;
  padding-right: 6px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.ticketCardsLG {
  margin-bottom: 5px !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.cardsBigger {
  padding-bottom: 4px !important;
  padding-left: 15px !important;
  padding-right: 10px !important;
}

.cardsBiggerLG {
  margin-bottom: 5px !important;
  padding-left: 6px !important;
  padding-right: 6px !important;
}
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255,255,255,0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
</style>
